export const createPricingSlice = (set, get) => ({
    subtotal: 0,
    shipping: 0,
    tax_fees: 0,
    total: 0,
    discount: 0,
    duty: 0,
    promo_error: "",
    promo_code: "",
    setPricing: (pricing) => set(pricing),
    pricingLoading: false,
    setPricingLoading: (value) => set({ pricingLoading: value }),
    setPromoCode: (value) => set({ promo_code: value }),
    clientSecret: "",
    setClientSecret: (value) => set({ clientSecret: value }),
    plan: "subscription",
    setPlan: (type) => set({ plan: type }),
});
